<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Gestione Modelli Documento</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="addDocumento">
              <v-icon color="primary"> mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Nuovo Modello Documento</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="saveDocumenti"
              class="ml-10"
            >
              <v-icon color="success"> mdi-floppy</v-icon>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="showFilter">
              <v-icon color="purple"> mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.replace('/home')"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>
      <v-data-table
        :items="modelliDocumento.filter((e) => e.validita == 1)"
        :headers="headers"
      >
        <template v-slot:[`item.magazzino_prelievo`]="{ item }">
          {{ getDesMagazzino(item.magazzino_prelievo) }}
        </template>
        <template v-slot:[`item.magazzino_versamento`]="{ item }">
          {{ getDesMagazzino(item.magazzino_versamento) }}
        </template>
        <template v-slot:[`item.modifica`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small elevation="1" @click="edit(item)">
                <v-icon color="primary"> mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Modifica</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small elevation="1" @click="elimina(item)">
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-dialog v-model="editDialog" width="50vw">
        <v-card>
          <v-toolbar class="indigo white--text" dense>
            <v-toolbar-title class="white--text">
              {{ dialogTitle }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="saveDocumento" small>
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="closeEdit" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>

          <v-progress-linear
            indeterminate
            color="cyan"
            v-if="loading"
            id="progress"
          >
          </v-progress-linear>

          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  dense
                  outlined
                  label="Codice Documento"
                  v-model="tempItem.codice_documento"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  outlined
                  label="Riferimento Tipo"
                  v-model="tempItem.cod_tipo_documento_rif"
                  :items="tipi"
                  item-text="des"
                  item-value="cod"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  outlined
                  label="Riferimento Documento"
                  v-model="tempItem.cod_documento_rif"
                  :items="modelliDocumento"
                  item-text="codice_documento"
                  item-value="codice_documento"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  dense
                  outlined
                  label="Magazzino Prelievo"
                  v-model="tempItem.magazzino_prelievo"
                  :items="magazzini"
                  item-value="id_magazzino"
                  item-text="des_magazzino"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  dense
                  outlined
                  label="Magazzino Versamento"
                  v-model="tempItem.magazzino_versamento"
                  :items="magazzini"
                  item-value="id_magazzino"
                  item-text="des_magazzino"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-dialog>
    </v-card>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "GestioneModelliDocumento",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      loading: false,
      modify: false,
      editDialog: false,
      filterVisible: false,
      dialogTitle: "",
      tempItem: {},
      editingItem: null,

      magazzini: [],
      tipi: [],
      modelliDocumento: [],
      headers: [
        {
          text: "Modifica",
          value: "modifica",
        },
        {
          text: "Codice Documento",
          value: "codice_documento",
        },
        {
          text: "Magazzino Prelievo",
          value: "magazzino_prelievo",
        },
        {
          text: "Magazzino Versamento",
          value: "magazzino_versamento",
        },
        {
          text: "Riferimento Tipo",
          value: "cod_tipo_documento_rif",
        },
        {
          text: "Riferimento Codice",
          value: "cod_documento_rif",
        },
        {
          text: "Elimina",
          value: "elimina",
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    let request = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "getmagazzini",
        token: localStorage.user_token,
      },
    };
    this.$store
      .dispatch("api", request)
      .then((res) => {
        this.magazzini = Array.from(res.data);
      })
      .catch((error) => {
        console.log(error);
        this.$refs.SnackbarQV.print("error", "Errore Caricamento Dati");
      });
      await this.getModelliDocumento();
      await this.getTabella();
      console.log(this.tipi);
      this.loading = false;
  },
  methods: {
    async getTabella(){
        let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "TIPO_DOCUMENTO",
          filter: `validita = 1`,
        },
      };

      // Gestisco la response.
      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.tipi =
              res.data != null && res.data != "" ? res.data : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    async getModelliDocumento() {
      this.loading = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodellidocumento",
          token: localStorage.user_token,
        },
      };
      await this.$store
        .dispatch("api", request)
        .then((res) => {
          this.modelliDocumento = Array.from(res.data.result.modello_documento);
        })
        .catch((error) => {
          console.log(error);
          this.$refs.SnackbarQV.print("error", "Errore Caricamento Dati");
        });
    },
    showFilter() {
      this.filterVisible = !this.filterVisible;
    },
    saveDocumenti() {
      this.loading = true;
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setmodellidocumento",
          modello_documento: this.modelliDocumento,
          token: localStorage.user_token,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.$refs.SnackbarQV.print("success", "Modelli Documento Salvati");
          this.modelliDocumento = Array.from(res.data.result.modello_documento);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.$refs.SnackbarQV.print("error", "Modelli Documento Non Salvati");
        });
    },
    getDesMagazzino(id) {
      for (let i = 0; i < this.magazzini.length; i++) {
        const e = this.magazzini[i];
        if (e.id_magazzino == id) {
          console.log(e.des_magazzino);
          return e.des_magazzino;
        }
      }
    },
    addDocumento() {
      this.modify = false;
      this.tempItem = {
        id_modello_documento: -1,
        codice_documento: "",
        magazzino_prelievo: -1,
        magazzino_versamento: -1,
        cod_tipo_documento_rif: "",
        cod_documento_rif: "",
        validita: 1,
      };
      this.dialogTitle = "Nuovo Modello Documento";
      this.editDialog = true;
    },
    closeEdit() {
      this.editDialog = false;
    },
    elimina(arg) {
      if (arg.id_modello_documento == -1) {
        var x = -1;
        for (let i = 0; i < this.modelliDocumento.length; i++) {
          const e = this.modelliDocumento[i];
          if (e.codice_documento == arg.codice_documento) {
            x = i;
            break;
          }
        }
        this.modelliDocumento.splice(x, 1);
      } else {
        arg.validita = 0;
      }
    },
    edit(arg) {
      this.editingItem = arg;
      this.tempItem = Object.assign({}, arg);
      this.modify = true;
      this.dialogTitle = "Modifica Modello Documento";
      this.editDialog = true;
    },
    saveDocumento() {
      if (this.modify) {
        this.editingItem.codice_documento = this.tempItem.codice_documento;
        this.editingItem.cod_tipo_documento_rif = this.tempItem.cod_tipo_documento_rif;
        this.editingItem.cod_documento_rif = this.tempItem.cod_documento_rif;
        this.editingItem.magazzino_prelievo = this.tempItem.magazzino_prelievo;
        this.editingItem.magazzino_versamento = this.tempItem.magazzino_versamento;
      } else {
        this.modelliDocumento.push(Object.assign({}, this.tempItem));
      }
      this.editDialog = false;
      this.$refs.SnackbarQV.print("success", "Modello Documento Salvato");
    },
  },
};
</script>